/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, Text } from "@chakra-ui/react";
import PageLayout from "components/layout/PageLayout";
import { axiosService } from "network/axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCardsRequest } from "store/user/reducer";
import { userSelector } from "store/user/selector";
import { alertSelector } from "store/ui/selector";
import { Notification } from "views/customer/project-detail/components/Notification";
import ServiceItem from "./components/ServiceItem";
import { servicesData } from "./variables/serviceData";

export default function Services() {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const alert = useSelector(alertSelector);
  const [allActiveProjects, setAllActiveProjects] = useState<any>([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    dispatch(getCardsRequest({ user_id: user.user_id }));
    fetchResults();
  }, []);

  useEffect(() => {
    if (alert?.type === "success" && alert?.message) {
      setSuccessMessage(alert.message);
      setErrorMessage("");
    } else if (alert?.type === "error" && alert?.message) {
      setErrorMessage(alert.message);
      setSuccessMessage("");
    }
  }, [alert]);

  useEffect(() => {
    if (!successMessage) return;
    const timer = setTimeout(() => setSuccessMessage(""), 15000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  useEffect(() => {
    if (!errorMessage) return;
    const timer = setTimeout(() => setErrorMessage(""), 15000);
    return () => clearTimeout(timer);
  }, [errorMessage]);

  const fetchResults = async () => {
    try {
      const resp: any = await axiosService.get(
        `/projects/list/${user?.user_id}?limit=1000&page=1`,
      );
      const { results } = resp?.data;
      setAllActiveProjects(
        results?.map((it: any) => ({
          ...it,
          id: it?.order_id,
        })),
      );
    } catch (err) {
      console.log(err);
      setAllActiveProjects([]);
    }
  };

  const certifiedServices = servicesData.filter((s) => s.group === "Certified");
  const standardServices = servicesData.filter((s) => s.group === "Standard");

  return (
    <PageLayout title="Services">
      <Box>
        <Notification
          successMessage={successMessage}
          errorMessage={errorMessage}
        />
        <Box mb="40px">
          <Text fontSize="18px" fontWeight="600" mb="8px" color="#0B0E10">
            Certified
          </Text>
          <Box h="1px" bg="#E5E7EB" mb="16px" />
          <Flex columnGap="24px" rowGap="24px" w="full" flexWrap="wrap">
            {certifiedServices.map((it, index: number) => (
              <ServiceItem
                w="full"
                maxW="333px"
                minW="333px"
                flexBasis={{
                  base: "100%",
                  xl: "calc((100% - 48px) / 3)",
                  md: "calc((100% - 24px) / 2)",
                }}
                flexGrow={1}
                item={it}
                allActiveProjects={allActiveProjects}
                key={index}
                onRefresh={fetchResults}
              />
            ))}
          </Flex>
        </Box>
        <Box>
          <Text fontSize="18px" fontWeight="600" mb="8px" color="#0B0E10">
            Standard
          </Text>
          <Box h="1px" bg="#E5E7EB" mb="16px" />
          <Flex columnGap="24px" rowGap="24px" w="full" flexWrap="wrap">
            {standardServices.map((it, index: number) => (
              <ServiceItem
                w="full"
                maxW="333px"
                minW="333px"
                flexBasis={{
                  base: "100%",
                  xl: "calc((100% - 48px) / 3)",
                  md: "calc((100% - 24px) / 2)",
                }}
                flexGrow={1}
                item={it}
                allActiveProjects={allActiveProjects}
                key={index}
                onRefresh={fetchResults}
              />
            ))}
          </Flex>
        </Box>
      </Box>
    </PageLayout>
  );
}
